import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
	Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '@core/services';
import { UserState } from '@shared/interfaces';
import { map, switchMap, take } from 'rxjs/operators';
import { AccountApi } from '@core/http';
import { isPlatformBrowser } from '@angular/common';
import { GlobalDataService } from '../services/global-data.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
	providedIn: 'root',
})
export class MyAccountResolver implements Resolve<any> {
	constructor(
		private authService: AuthService,
		private accountApi: AccountApi,
		private globalDataService: GlobalDataService,
		private http: HttpClient
	) {}
	resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<any> {
		const isMyAccount = state.url.includes('my-account');

		if (!this.globalDataService.getGlobalData()) {
			this.http
				.get(environment.getDataByUUID + 'f5340163-c1ec-419f-866f-02d17652434a')
				.subscribe((data: any) => {
					this.http
						.get(data?.items['brxm:resourceBundles'][0]?.link?.url)
						.subscribe((res: any) => {
							let filterData: any = {};

							if (res?.keys && typeof res.keys === 'object') {
								for (let key in res.keys) {
									const value = res.keys[key]?.default ?? null;
									filterData[key] = value;
								}
							}
							this.globalDataService.setGlobalData(filterData);
						});
				});
		}

		if (!!isMyAccount) {
			return this.authService.getUserState$().pipe(
				take(1),
				map((userState: UserState) => {
					const user_id = userState?.user_id ? userState?.user_id : '';
					return !!user_id ? user_id?.toString()?.replace(/"/g, '') : null;
				}),
				switchMap((uid: string) => {
					// retrieve favorites data as observable
					// fetch user info
					return this.accountApi.fetchUser$(uid).pipe(take(1));
				})
			);
		}

		return of(null);
	}
}
